import React from 'react';
import { resolverEstatusEmpleado } from '../../utils/estatusEmpleado';
import { inicialesEmpleado } from '../../utils/inicialesEmpleado';

// Datos de presentación comunes a tarjeta y credencial, sólo desde la lista
// (api/empleados): nunca "—", "undefined" ni separadores huérfanos.
export function presentarEmpleado(empleado) {
  const nombre = String(empleado.nombre || '').trim();
  const id = String(empleado.id == null ? '' : empleado.id).trim();
  const estatus = resolverEstatusEmpleado(null, empleado);
  return {
    nombre,
    id,
    iniciales: nombre ? inicialesEmpleado(nombre) : '',
    estatus,
    textoEstatus: estatus.valor ? estatus.texto : 'Sin estatus',
    puesto: String(empleado.puesto || '').trim(),
    area: String(empleado.area || '').trim()
  };
}

export function TarjetaEmpleado({ empleado, onAbrir }) {
  const p = presentarEmpleado(empleado);
  const puestoArea = [p.puesto, p.area].filter(Boolean).join(' · ');

  return (
    <button type="button" className="m-emp-card" onClick={() => onAbrir(p.id)}>
      <span className={`m-emp-avatar m-tono-${p.estatus.tipo}`} aria-hidden="true">
        {p.iniciales || <i className="ti ti-user"></i>}
      </span>
      <span className="m-emp-cuerpo">
        <span className="m-emp-nombre">{p.nombre || 'Sin nombre'}</span>
        <span className="m-emp-meta">
          {p.id && <span className="m-emp-num">#{p.id}</span>}
          <span className={`m-estatus m-estatus-${p.estatus.tipo}`}>
            <span className="m-estatus-punto" aria-hidden="true"></span>{p.textoEstatus}
          </span>
        </span>
        {puestoArea && <span className="m-emp-puesto">{puestoArea}</span>}
      </span>
      <i className="ti ti-chevron-right m-emp-chev" aria-hidden="true"></i>
    </button>
  );
}
